import React from 'react';

export default ({ record }) => {
  return (
    <span>
      User
      {record ? `: ${record.first_name} ${record.last_name}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/User/Title.js